module.exports = __webpack_public_path__ + "img/a1e1e4c69def1bf201232cbb52a81c0b.88203013.png";